module.exports = __webpack_public_path__ + "static/media/brazil.65af59f9.svg";